import React from 'react';
import Router from 'next/router';
import PATH from "@bigyellow/routes";

export const redirect = (to) => Router.replace(to.replace(PATH, ''));
